import styles from "./ScreenTitle.module.scss";

const ScreenTitle = ({ children }) => {
  return (
    <section className={" "}>
      <h2 className={styles.screentitle}>{children}</h2>
    </section>
  );
};
export default ScreenTitle;
